import SendMessageDialog from './container'
export { SendMessageDialog }
export default SendMessageDialog